import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import LogoPNG from "../../../../src/assets/images/logo.png"; // same logo as invoice

const styles = StyleSheet.create({
  page: {
    width: 870,
    height: 1000,
    paddingTop: 35,
    paddingBottom: 35,
    paddingLeft: 50,
    paddingRight: 50,
  },
  logo: { width: 160, height: 100 },
  text: { fontSize: 11, fontFamily: "Helvetica" },
  title: { fontFamily: "Helvetica-Bold", fontWeight: "bold", fontSize: 11 },
  title2: {
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    fontSize: 13,
    textAlign: "center",
  },
  bold: { fontFamily: "Helvetica-Bold", fontWeight: "bold" },
  section: { flexDirection: "row", flexGrow: 0, marginBottom: 15 },
  session1: { width: "60%", marginRight: 20 },
  session2: { width: "40%" },
  address: { fontSize: 10 },
  signature: { marginTop: 50, textAlign: "left" },
  signatureImage: { width: 150, height: 60, marginTop: 10 },
  footer: {
    position: "absolute",
    bottom: 40,
    left: 40,
    fontSize: 9,
    textAlign: "center",
  },
  signedOn: { position: "absolute", bottom: 40, right: 40, fontSize: 9 },
  horizontalLine: {
    width: "100%",
    height: 1, // thickness of the line
    backgroundColor: "#000", // color of the line
    marginVertical: 10, // space above and below
  },
});

// eslint-disable-next-line import/no-anonymous-default-export
const MedicalCertificatePDF = ({ certificate, setting }) => {
  return (
    <Document>
      <Page style={styles.page}>
        {/* Header (Same as Invoice) */}
        <View style={styles.section}>
          <View>
            <Image src={LogoPNG} style={styles.logo} />
          </View>
          <View style={{ textAlign: "right", width: "100%" }}>
            <Text style={{ ...styles.text, ...styles.title, marginBottom: 6 }}>
              EPION CLINIC MEDICAL AESTHETICS
            </Text>
            <Text style={{ ...styles.text, ...styles.bold, marginBottom: 6 }}>
              Company UEN: {setting?.companyUEN}
            </Text>
            <Text style={{ ...styles.text, ...styles.bold, marginBottom: 6 }}>
              GST No: {setting?.companyGST}
            </Text>
            <Text
              style={{ ...styles.text, ...styles.address, marginBottom: 6 }}
            >
              {setting?.companyAddress}
            </Text>
            <Text style={{ ...styles.text, ...styles.address }}>
              {setting?.companyContactNo} | {setting?.companyEmail}
            </Text>
            <Text style={{ ...styles.text, ...styles.address }}>
              {setting?.companySite}
            </Text>
          </View>
        </View>

        <Text style={{ ...styles.title2, marginBottom: 5, marginTop: 5 }}>
          Medical Certificate
        </Text>
        <View style={{ ...styles.horizontalLine, marginBottom: 10 }} />

        <View style={{ marginBottom: 10 }}>
          <Text style={{ ...styles.text, textAlign: "right" }}>
            <Text style={styles.bold}>Issue Date: </Text>
            {new Date(certificate.issueDate).toLocaleDateString()}
          </Text>
        </View>

        <View style={{ marginBottom: 10 }}>
          <Text style={{ ...styles.text, textAlign: "right" }}>
            <Text style={styles.bold}>Reference No: </Text>
            {certificate.referenceNo || "-"}
          </Text>
        </View>

        <View style={{ marginBottom: 10 }}>
          <Text style={styles.text}>
            <Text style={styles.bold}>Name: </Text>
            {certificate.patient.patientProfile.fullName}
          </Text>
        </View>

        <View style={{ marginBottom: 10 }}>
          <Text style={styles.text}>
            <Text style={styles.bold}>Leave Type: </Text>
            {certificate.mcType}
          </Text>
        </View>

        <View style={{ marginBottom: 10 }}>
          <Text style={styles.text}>
            <Text style={styles.bold}>From: </Text>
            {new Date(certificate.fromDate).toLocaleDateString()}
          </Text>
        </View>

        <View style={{ marginBottom: 10 }}>
          <Text style={styles.text}>
            <Text style={styles.bold}>To: </Text>
            {new Date(certificate.toDate).toLocaleDateString()}
          </Text>
        </View>

        <View style={{ marginBottom: 10 }}>
          <Text style={styles.text}>
            <Text style={styles.bold}>Doctor: </Text>
            {certificate.doctor}
          </Text>
        </View>

        <View style={{ marginBottom: 10 }}>
          <Text style={styles.text}>
            <Text style={styles.bold}>Description: </Text>
            {certificate.description}
          </Text>
        </View>

        {certificate.mcType === "attendance" && certificate.accompaniedBy && (
          <View style={{ marginBottom: 10 }}>
            <Text style={styles.text}>
              <Text style={styles.bold}>Accompanied By: </Text>
              {certificate.accompaniedBy}
            </Text>
          </View>
        )}

        {/* Signature */}
        <View style={styles.signature}>
          {certificate.signature && (
            <Image src={certificate.signature} style={styles.signatureImage} />
          )}
          <View style={{ marginTop: 10, marginLeft: 20 }}>
            <Text style={{ ...styles.text, ...styles.bold }}>
              {certificate.doctor}
            </Text>
          </View>
        </View>

        {/* Footer */}
        <Text style={styles.footer}>
          This certificate is not valid for absence from court attendance
        </Text>
        <Text style={styles.signedOn}>
          Signed on {new Date(certificate.issueDate).toLocaleDateString()}{" "}
          {new Date(certificate.issueDate).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Text>
      </Page>
    </Document>
  );
};

export default MedicalCertificatePDF;
